import { render, staticRenderFns } from "./station.vue?vue&type=template&id=6529d47a&scoped=true&"
import script from "./station.vue?vue&type=script&lang=js&"
export * from "./station.vue?vue&type=script&lang=js&"
import style0 from "./station.vue?vue&type=style&index=0&id=6529d47a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6529d47a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6529d47a', component.options)
    } else {
      api.reload('6529d47a', component.options)
    }
    module.hot.accept("./station.vue?vue&type=template&id=6529d47a&scoped=true&", function () {
      api.rerender('6529d47a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/markers/station.vue"
export default component.exports